module.exports = __webpack_public_path__ + "static/img/CM.e408ecab.png";